import { render, staticRenderFns } from "./coreValues_edit.vue?vue&type=template&id=019a9248&scoped=true"
import script from "./coreValues_edit.vue?vue&type=script&lang=js"
export * from "./coreValues_edit.vue?vue&type=script&lang=js"
import style0 from "./coreValues_edit.vue?vue&type=style&index=0&id=019a9248&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019a9248",
  null
  
)

export default component.exports